import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaBuilding, FaSignInAlt } from 'react-icons/fa';
import { useTenantInfo } from '../../hooks/useTenantInfo';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { displayName } = useTenantInfo();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="website-header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/home" className="logo-section">
            <div className="logo-icon">
              <FaBuilding />
            </div>
            <span className="brand-name">{displayName}</span>
          </Link>
        </div>

        <nav className="header-nav">
          <Link to="/home" className={`nav-link ${isActive('/home')}`}>Home</Link>
          <Link to="/services" className={`nav-link ${isActive('/services')}`}>Services</Link>
          <Link to="/contact" className={`nav-link ${isActive('/contact')}`}>Contact Us</Link>
        </nav>

        <div className="header-right">
          <button onClick={handleLoginClick} className="login-button">
            <FaSignInAlt /> Login
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
